import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { Eyebrow, Reveal, SectionTitle } from "./Reveal";
import { FAQS } from "./data";

export default function Faq() {
  return (
    <section data-testid="faq-section" className="bg-ivory">
      <div className="mx-auto max-w-editorial px-6 py-24 md:px-10 md:py-32">
        <div className="grid gap-14 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-32">
              <Reveal>
                <Eyebrow>Practical matters</Eyebrow>
              </Reveal>
              <Reveal delay={0.12}>
                <SectionTitle before="Before you" accent="pack your bags" className="mt-8" />
              </Reveal>
              <Reveal delay={0.2}>
                <p className="mt-8 max-w-sm text-sm leading-[1.85] text-fog">
                  Everything else — visas, packing lists, reading lists — arrives in a personal note once your
                  departure is confirmed.
                </p>
              </Reveal>
            </div>
          </div>

          <div className="lg:col-span-7">
            <Reveal delay={0.1}>
              <Accordion type="single" collapsible data-testid="faq-accordion">
                {FAQS.map((faq, i) => (
                  <AccordionItem key={faq.q} value={`faq-${i}`} className="border-ink/12">
                    <AccordionTrigger
                      data-testid={`faq-trigger-${i}`}
                      className="py-6 text-left font-serif text-xl font-light text-ink hover:text-leaf hover:no-underline md:text-2xl [&>svg]:text-saffron"
                    >
                      {faq.q}
                    </AccordionTrigger>
                    <AccordionContent data-testid={`faq-content-${i}`} className="pb-6 text-[14.5px] leading-[1.85] text-fog">
                      {faq.a}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
